<template>
    <div v-if="isEditable">
        <input size="mini" @blur="emit" v-focus v-model="newValue" @keyup.enter="stopEdition" @keyup.esc="cancelEdition">
    </div>
    <div v-else @click="allowEdition">
        <span> {{ scope.row[scope.column.property] }} </span>
    </div>
</template>

<script>
import formatters from '@/services/formatters';

export default {
    data() {
        return {
            isEditable: false,
            newValue: this.scope.row[this.scope.column.property]
        }
    },
    props: {
        scope: Object,
    },
    methods: {
        emit() {
            this.$emit('saveToFirestore', this.newValue, this.scope, false)
            this.isEditable = false
        },
        allowEdition() {
            this.newValue = this.scope.row[this.scope.column.property]
            this.isEditable = true
        },
        stopEdition() {
            this.scope.row[this.scope.column.property] = this.newValue
            this.isEditable = false
        },
        cancelEdition() {
            this.isEditable = false
        }
    }
}
</script>

<style>
input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}
.fs_icon {
    float: left; 
    color: red;
}
</style>